import { webPageStyle } from '@app/styles/dashboard-styles'
import { FC } from 'react'
import { Website } from '@app/types'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { WebsiteListProps } from '@app/types/websitelist'
import { LoadMoreButton } from '../../buttons'
import { WebsiteListMock } from './websites-dashboard-list-mock'

interface PureWebsiteListProps extends WebsiteListProps {
  sortModalVisible?: boolean
  queryModalVisible?: boolean
  data?: Website[]
  loading?: boolean
  mutatationLoading?: boolean
  translation?: string
  onLoadMoreWebsites?(x: any): Promise<void>
}

// multiple website list
export const PureWebsiteListMock: FC<
  PureWebsiteListProps & { onlyLive?: boolean }
> = ({
  data,
  translation,
  sortModalVisible,
  queryModalVisible,
  activeCrawls,
  removePress,
  loading,
  mutatationLoading,
  error,
  onLoadMoreWebsites,
  crawlWebsite,
  setModal,
  refetch,
  onlyLive,
}) => {
  const { t } = useTranslation(translation || 'dashboard')

  return (
    <div className={webPageStyle({ sortModalVisible, queryModalVisible })}>
      <WebsiteListMock
        emptyHeaderTitle={t('welcome')}
        emptyHeaderSubTitle={t('welcome-sub')}
        data={data}
        error={error}
        loading={loading}
        mutatationLoading={mutatationLoading}
        removePress={removePress}
        crawlWebsite={crawlWebsite}
        refetch={refetch}
        setModal={setModal}
        activeCrawls={activeCrawls}
        onlyLive={onlyLive}
      >
        <li>
          <LoadMoreButton
            visible={data && data.length > 1}
            onLoadMoreEvent={onLoadMoreWebsites}
          />
        </li>
      </WebsiteListMock>
    </div>
  )
}
